import React, { useEffect, useState } from "react";
import { Box, Typography, Grid2 } from "@mui/material";
import SearchOffOutlinedIcon from "@mui/icons-material/SearchOffOutlined";
import SingleCard from "../../../AdsPage/SingleCard";
import { Helmet } from "react-helmet-async";
import AnalyticsTracker from "../../../GASetup/AnalyticsTracker";
import LoadingAnimation from "../../../Animations/LoadingAnimation";
import { fonts, headingFonts, notFoundBox } from "../../../../Styles/Styles";

export default function Favorites() {
  const [favoriteAds, setFavoriteAds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFavoriteAds = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_SERVER_BASE_URL}/user/favorites/all`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch favorite ads");
        }
        const data = await response.json();
        setFavoriteAds(data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchFavoriteAds();
  }, []);
  console.log(favoriteAds);

  if (loading) return <LoadingAnimation />;
  if (error) return <Typography color="error">{error}</Typography>;

  return (
    <Box sx={{ padding: 3 }}>
      <Helmet>
        <title>Favorites Ads - Listed.ky</title>
        <meta name="description" content="Favorites Ads - Listed.ky" />
      </Helmet>
      <AnalyticsTracker />
      <Typography variant="h4" mb={2} sx={{ ...headingFonts }}>
        My Favorite Ads
      </Typography>
      {favoriteAds.length === 0 ? (
        <Box sx={{ ...notFoundBox }}>
          <SearchOffOutlinedIcon
            sx={{
              color: "var(--primary-color)",
              fontSize: 50,
              opacity: 0.5,
              marginBottom: 1,
            }}
          />
          <Typography
            variant="h6"
            sx={{
              color: "var(--primary-color)",
              ...headingFonts,
            }}
          >
            No Favorite Ads found.
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.7, ...fonts }}>
            Easily add ads to your favorites by clicking the Heart icon on the
            Ad's card.
          </Typography>
        </Box>
      ) : (
        <Grid2 container spacing={3}>
          {favoriteAds.map((ad, index) => (
            <Grid2 item size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={index}>
              <SingleCard AdInfo={ad} />
            </Grid2>
          ))}
        </Grid2>
      )}
    </Box>
  );
}
